// mixtalk.js

(function ($) {
  window.isMixtalk = true;

  //Der Footer muss per JS umgebaut werden:
  const $footer = $('#footer');

  if($footer.length !== 0) {
    const $menuboxFirst = $footer.find('.menubox.first > ul');
    const $menuboxSecond = $footer.find('.menubox:not(.first) > ul');

    if ($menuboxFirst.find('li:has(a[href*="twitch.tv"])').length === 0) {
      //Wenn das HTML noch nicht die neuen Footer-Navi-Punkte enthält, soll es durch das
      //HTML ersetzt werden, das die Navipunkte von Mixtalk enthält.
      $menuboxFirst.empty();

      if (window.location.host.indexOf('demo-vorschau') !== -1) {
        //DEMO-Vorschau
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="https://www.twitch.tv/ard" title="Mixtalk auf Twitch" class="link">Mixtalk auf Twitch' +
            SWRNEU.Util.svgIcon("external-link") +
          '  </a>' +
          '</li>'));
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="/swr/mixtalk/mixtalk-artikel-100.html" title="Nutzungsbedingungen" class="link">Nutzungsbedingungen</a>' +
          '</li>'));
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="/swr/mixtalk/formular-kontakt-mixtalk-100.html" title="Kontakt zur Redaktion" class="link">Kontakt zur Redaktion</a>' +
          '</li>'));
      } else if (window.location.host.indexOf('demo.swr.de') !== -1) {
        //DEMO
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="https://www.twitch.tv/ard" title="Mixtalk auf Twitch" class="link">Mixtalk auf Twitch' +
              SWRNEU.Util.svgIcon("external-link") +
          '  </a>' +
          '</li>'));
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="/mixtalk/mixtalk-artikel-100.html" title="Nutzungsbedingungen" class="link">Nutzungsbedingungen</a>' +
          '</li>'));
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="/mixtalk/formular-kontakt-mixtalk-100.html" title="Kontakt zur Redaktion" class="link">Kontakt zur Redaktion</a>' +
          '</li>'));
      } else if (window.isFractal) {
        //Fractal
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="https://www.twitch.tv/ard" title="Mixtalk auf Twitch" class="link">Mixtalk auf Twitch' +
                SWRNEU.Util.svgIcon("external-link") +
          '  </a>' +
          '</li>'));
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="#" title="Nutzungsbedingungen" class="link">Nutzungsbedingungen</a>' +
          '</li>'));
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="#" title="Kontakt zur Redaktion" class="link">Kontakt zur Redaktion</a>' +
          '</li>'));
      } else if (window.location.host.indexOf('prod-vorschau') !== -1) {
        //PROD-Vorschau
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="https://www.twitch.tv/ard" title="Mixtalk auf Twitch" class="link">Mixtalk auf Twitch' +
                SWRNEU.Util.svgIcon("external-link") +
          '  </a>' +
          '</li>'));
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="/swr/mixtalk/nutzungsbedingungen-104.html" title="Nutzungsbedingungen" class="link">Nutzungsbedingungen</a>' +
          '</li>'));
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="/swr/mixtalk/formular-kontakt-mixtalk-100.html" title="Kontakt zur Redaktion" class="link">Kontakt zur Redaktion</a>' +
          '</li>'));
      } else {
        //PROD
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="https://www.twitch.tv/ard" title="Mixtalk auf Twitch" class="link">Mixtalk auf Twitch' +
                SWRNEU.Util.svgIcon("external-link") +
          '  </a>' +
          '</li>'));
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="/mixtalk/nutzungsbedingungen-104.html" title="Nutzungsbedingungen" class="link">Nutzungsbedingungen</a>' +
          '</li>'));
        $menuboxFirst.append($('' +
          '<li>' +
          '  <a href="/mixtalk/formular-kontakt-mixtalk-100.html" title="Kontakt zur Redaktion" class="link">Kontakt zur Redaktion</a>' +
          '</li>'));
      }

      const $impressum = $menuboxSecond.find('li:has(a[href*="impressum"])');
      const $datenschutz = $menuboxSecond.find('li:has(a[href*="datenschutz"])');
      $datenschutz.after($impressum);
    }
  }
})(window.jQuery);
